import script from "./MainSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./MainSidebar.vue?vue&type=style&index=0&id=0e718120&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e718120"]])

export default __exports__